export default "__VITE_ASSET__BsukJ1eb__"